// ================================
// 設定値
// ================================
const CART_FORM_SELECTOR = 'form[action="/cart"]';
const CART_ITEM_TAG_CLASS = 'item_tags';
const HAI_SO_CONTAINER_ID = 'haisosm_et';
const HIDE_TARGET_TAG = '配送日時指定不可';
//アプリ設定画面上　['日付指定属性名', '時間帯指定属性名'];
const ATTRIBUTE_KEYS = ['delivery_date', 'delivery_time'];

// ================================
// 初期化
// ================================
document.addEventListener('DOMContentLoaded', () => {
  const cartForm = document.querySelector(CART_FORM_SELECTOR);
  if (!cartForm) return;

  const observer = new MutationObserver(handleCartMutation);
  observer.observe(cartForm, { childList: true, subtree: true });

  // 初期判定
  updateHaisoVisibility();
});

// ================================
// MutationObserver
// ================================
function nodeAffectsCart(node) {
  if (node.nodeType !== 1) return false;

  return (
    node.classList?.contains('cart__items') ||
    node.classList?.contains(CART_ITEM_TAG_CLASS) ||
    node.querySelector?.(`.${CART_ITEM_TAG_CLASS}`)
  );
}

function handleCartMutation(mutations) {
  for (const mutation of mutations) {
    if (mutation.type !== 'childList') continue;

    const shouldRecheck =
      [...mutation.addedNodes].some(nodeAffectsCart) ||
      [...mutation.removedNodes].some(nodeAffectsCart);

    if (shouldRecheck) {
      updateHaisoVisibility();
      return;
    }
  }
}

// ================================
// 表示制御ロジック
// ================================
function updateHaisoVisibility() {
  console.log("initial check");
  
  const haisoContainer = document.getElementById(HAI_SO_CONTAINER_ID);
  if (!haisoContainer) return;

  const shouldHide = hasTargetTagInCart();

  haisoContainer.style.display = shouldHide ? 'none' : 'block';

  if (shouldHide) {
    clearHaisoAttributes();
  }
}

// cart 内に対象タグがあるか
function hasTargetTagInCart() {
  const tagElements = document.getElementsByClassName(CART_ITEM_TAG_CLASS);

  for (const el of tagElements) {
    const text = el.textContent || '';
    if (text.includes(HIDE_TARGET_TAG)) {
      return true;
    }
  }
  return false;
}

// ================================
// カート属性クリア
// ================================
function clearHaisoAttributes() {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      attributes: ATTRIBUTE_KEYS.reduce((obj, key) => {
        obj[key] = '';
        return obj;
      }, {})
    })
  })
    .then(res => res.json())
    .then(syncAttributeInputs)
    .catch(console.error);
}

// ================================
// input / select 表示同期
// ================================
function syncAttributeInputs() {
  fetch('/cart.js', {
    headers: { 'Accept': 'application/json' }
  })
    .then(res => res.json())
    .then(({ attributes }) => {
      ATTRIBUTE_KEYS.forEach(key => {
        if (!attributes[key]) {
          clearAttributeField(key);
        }
      });
    });
}

function clearAttributeField(key) {
  document
    .querySelectorAll(`input[name="attributes[${key}]"], select[name="attributes[${key}]"]`)
    .forEach(el => {
      el.value = '';
          // テーマJS・datepicker対策
      el.dispatchEvent(new Event('change', { bubbles: true }));
      el.dispatchEvent(new Event('input', { bubbles: true }));
    });

}
